import { Button, ButtonSize, ButtonVariant } from "shared/components";

export const Footer = ({
  onClose,
  isPending
}: {
  onClose: () => void;
  isPending: boolean;
}) => {
  return (
    <div className="flex justify-end gap-2 px-6 py-4 border-t border-alpha-100 bg-white sticky bottom-0 z-10">
      <Button
        size={ButtonSize.BASE}
        className="w-[125px]"
        variant={ButtonVariant.BASE}
        onClick={onClose}
      >
        Cancel
      </Button>
      <Button
        size={ButtonSize.BASE}
        className="w-[125px]"
        variant={ButtonVariant.PRIMARY}
        type="submit"
        loading={isPending}
      >
        Save
      </Button>
    </div>
  );
};
